'use strict';

export default function ($stateProvider, $urlRouterProvider) {
  'ngInject';

  $urlRouterProvider.when("/tpFirmwares", "/tpFirmwares/list");

  $stateProvider
    .state('tpFirmwares', {
      url: '/tpFirmwares',
      template: require('./tpFirmwares.html'),
      authenticate: true
    })
    .state('tpFirmwares.list', {
      url: '/list',
      template: require('./list/list.html'),
      controller: 'TpFirmwaresListController',
      controllerAs: 'tpListCtrl'
    })
    .state('tpFirmwares.add', {
      url: '/add',
      template: require('./add/add.html'),
      controller: 'TpFirmwaresAddController',
      controllerAs: 'tpAddCtrl'
    })
    .state('tpFirmwares.edit', {
      url: '/edit/:id',
      template: require('./edit/edit.html'),
      controller: 'TpFirmwaresEditController',
      controllerAs: 'tpEditCtrl'
    });
}



// WEBPACK FOOTER //
// ./client/app/tpFirmwares/tpFirmwares.routes.js